module.exports = __webpack_public_path__ + "img/no_image.5e1b1658.png";